import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { type PolicyBundleWithEligibility } from '../../utils/types/Entity';

interface PolicyBundleState {
  ready: boolean;
  policyBundles: PolicyBundleWithEligibility[];
  selectedPolicyBundleID: string;
}

const policyBundlesInitialState: PolicyBundleState = {
  ready: false,
  policyBundles: [],
  selectedPolicyBundleID: '',
};

const policyBundlesSlice = createSlice({
  name: 'policyBundles',
  initialState: policyBundlesInitialState,
  reducers: {
    setPolicyBundles: (
      state: PolicyBundleState,
      action: PayloadAction<PolicyBundleWithEligibility[]>,
    ) => {
      state.policyBundles = action.payload;
    },
    setSelectedPolicyBundle: (
      state: PolicyBundleState,
      action: PayloadAction<string>,
    ) => {
      state.selectedPolicyBundleID = action.payload;
    },
    setPolicyBundlesReady: (state: PolicyBundleState) => {
      state.ready = true;
    },
    setUpdatedPolicyBundle: (
      state: PolicyBundleState,
      action: PayloadAction<PolicyBundleWithEligibility>,
    ) => {
      state.policyBundles = state.policyBundles.map((bundle) => {
        if (bundle.id === action.payload.id) {
          return action.payload;
        }
        return bundle;
      });
    },
  },
});

export const policyBundlesActions = policyBundlesSlice.actions;

export const policyBundlesReducer = policyBundlesSlice.reducer;
